import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function UrgencySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-bg)'
  }} data-id="element-306">
      <div className="max-w-2xl mx-auto" data-id="element-307">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-308">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-309">
            El costo de no actuar
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-310">
            Cada día que no trabajas tu programación mental, no estás en pausa.
          </h2>

          <p className="text-2xl font-black mb-10" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-accent)'
        }} data-id="element-311">
            Estás consolidando.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="space-y-4 mb-12" data-id="element-312">
          <div className="flex items-center gap-4 p-5 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-313">
            <span className="text-xl" data-id="element-314">📉</span>
            <p className="text-lg" style={{
            color: 'var(--color-text)'
          }} data-id="element-315">
              Consolidando el techo financiero que te limita.
            </p>
          </div>
          <div className="flex items-center gap-4 p-5 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-316">
            <span className="text-xl" data-id="element-317">🔄</span>
            <p className="text-lg" style={{
            color: 'var(--color-text)'
          }} data-id="element-318">
              Consolidando los patrones que reconoces y odias.
            </p>
          </div>
          <div className="flex items-center gap-4 p-5 rounded-sm" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-border)'
        }} data-id="element-319">
            <span className="text-xl" data-id="element-320">↔️</span>
            <p className="text-lg" style={{
            color: 'var(--color-text)'
          }} data-id="element-321">
              Consolidando la brecha entre quien eres y quien sabes que puedes
              ser.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.7
      }} data-id="element-322">
          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-323">
            El tiempo pasa de todas formas.
          </p>

          <p className="text-xl font-bold mb-10" style={{
          color: 'var(--color-text)'
        }} data-id="element-324">
            La pregunta no es si vas a cambiar.{' '}
            <span style={{
            color: 'var(--color-accent)'
          }} data-id="element-325">
              La pregunta es si el cambio va a ocurrirte — o si lo vas a
              construir.
            </span>
          </p>

          <div className="py-8 px-8 rounded-sm text-center" style={{
          background: 'var(--color-surface)',
          border: '1px solid var(--color-accent)'
        }} data-id="element-326">
            <p className="text-lg mb-2" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-327">
              Dentro de 90 días, vas a ser alguien.
            </p>
            <p className="text-2xl font-black" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-328">
              La única variable es quién.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}